/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateUpdateContractEstimateItemDto } from './CreateUpdateContractEstimateItemDto';
import {
    CreateUpdateContractEstimateItemDtoFromJSON,
    CreateUpdateContractEstimateItemDtoFromJSONTyped,
    CreateUpdateContractEstimateItemDtoToJSON,
} from './CreateUpdateContractEstimateItemDto';

/**
 * 
 * @export
 * @interface CreateUpdateContractEstimateItemsDto
 */
export interface CreateUpdateContractEstimateItemsDto {
    /**
     * 
     * @type {Array<CreateUpdateContractEstimateItemDto>}
     * @memberof CreateUpdateContractEstimateItemsDto
     */
    contractEstimateItems: Array<CreateUpdateContractEstimateItemDto>;
}

/**
 * Check if a given object implements the CreateUpdateContractEstimateItemsDto interface.
 */
export function instanceOfCreateUpdateContractEstimateItemsDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "contractEstimateItems" in value;

    return isInstance;
}

export function CreateUpdateContractEstimateItemsDtoFromJSON(json: any): CreateUpdateContractEstimateItemsDto {
    return CreateUpdateContractEstimateItemsDtoFromJSONTyped(json, false);
}

export function CreateUpdateContractEstimateItemsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateContractEstimateItemsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'contractEstimateItems': ((json['contractEstimateItems'] as Array<any>).map(CreateUpdateContractEstimateItemDtoFromJSON)),
    };
}

export function CreateUpdateContractEstimateItemsDtoToJSON(value?: CreateUpdateContractEstimateItemsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'contractEstimateItems': ((value.contractEstimateItems as Array<any>).map(CreateUpdateContractEstimateItemDtoToJSON)),
    };
}

